const PAYMENT_RESPONSE_KEY = "checkout_payment_response";
const PENDING_KEY = "checkout_pending";

export function buildCartFingerprint(orderItems) {
  if (!Array.isArray(orderItems)) return "";
  return orderItems
    .map((i) => `${i.variant_id || i.variant?.id}:${i.quantity}`)
    .sort()
    .join("|");
}

export function saveCheckoutPending({
  orderId,
  trackingToken,
  razorpayOrderId,
  couponCode,
  cartFingerprint,
  checkoutUserKey,
}) {
  sessionStorage.setItem(
    PENDING_KEY,
    JSON.stringify({
      orderId,
      trackingToken,
      razorpayOrderId,
      couponCode: couponCode || null,
      cartFingerprint: cartFingerprint || null,
      checkoutUserKey: checkoutUserKey || "guest",
    }),
  );
}

export function getCheckoutUserKey(user) {
  return user?.id ? String(user.id) : "guest";
}

export function getReusablePendingOrderId({
  cartFingerprint,
  couponCode,
  checkoutUserKey,
}) {
  const pending = getCheckoutPending();
  if (!pending?.orderId) return undefined;
  if (!pending.checkoutUserKey || pending.checkoutUserKey !== checkoutUserKey) {
    return undefined;
  }
  if (pending.cartFingerprint !== cartFingerprint) return undefined;
  if ((pending.couponCode || "") !== (couponCode || "")) return undefined;
  return pending.orderId;
}

export function savePaymentResponse({
  trackingToken,
  orderId,
  orderNumber,
  razorpay_order_id,
  razorpay_payment_id,
  razorpay_signature,
}) {
  sessionStorage.setItem(
    PAYMENT_RESPONSE_KEY,
    JSON.stringify({
      trackingToken,
      orderId,
      orderNumber,
      razorpay_order_id,
      razorpay_payment_id,
      razorpay_signature,
      savedAt: Date.now(),
    }),
  );
}

export function getPaymentResponse() {
  try {
    const raw = sessionStorage.getItem(PAYMENT_RESPONSE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed?.razorpay_payment_id || !parsed?.razorpay_signature) {
      return null;
    }
    if (parsed.savedAt && Date.now() - parsed.savedAt > 24 * 60 * 60 * 1000) {
      sessionStorage.removeItem(PAYMENT_RESPONSE_KEY);
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
}

export function clearCheckoutSession() {
  sessionStorage.removeItem(PAYMENT_RESPONSE_KEY);
  sessionStorage.removeItem(PENDING_KEY);
}

export function getCheckoutPending() {
  try {
    const raw = sessionStorage.getItem(PENDING_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}
